export default __webpack_public_path__ + "static/media/nightsun.e5a2fdde.png";